(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["balsamo-benefits-flip"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    (root || document).querySelectorAll('.bff__card').forEach(function (card) {
      if (card.dataset.bffInit) return;
      card.dataset.bffInit = '1';
      card.addEventListener('click', function () { card.classList.toggle('is-flipped'); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); card.classList.toggle('is-flipped'); }
      });
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
